import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadVerdicts } from 'services/api/NumberRegistrationAPI';
import { queryKeys } from '../queryKeys';

export interface UploadVerdictsParams {
    tenantId: string;
    file: File;
}

export const useUploadVerdicts = () => {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: ({ tenantId, file }: UploadVerdictsParams) => uploadVerdicts(tenantId, file),
        onSuccess: (_result, { tenantId }) => {
            // An ingest can propose new releases, so the proposals list is stale
            // the moment this returns.
            queryClient.invalidateQueries({ queryKey: queryKeys.releaseProposals(tenantId) });
        },
    });

    return { uploadVerdicts: mutateAsync, isUploadingVerdicts: isPending };
};
